/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-lonely-if */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
import React, { useRef, useCallback, useState, useEffect } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { useHistory, Link } from 'react-router-dom';
import { HiDownload } from 'react-icons/hi';
import { MdFilterList, MdSearch, MdContentCopy } from 'react-icons/md';
import { VscChromeClose } from 'react-icons/vsc';
import { FaReceipt, FaTrash, FaBarcode } from 'react-icons/fa';
import { IoCartOutline } from 'react-icons/io5';
import DownLoadFile from '../../utils/DownLoadFile';
import { useToast } from '../../hooks/toast';
import isArrayBuffer from '../../utils/isArrayBuffer';
import ConverArrayBufferToData from '../../utils/ConverArrayBufferToData';
import { ArrayFilters } from '../../interfaces/core';
import { RechargeTicketOrders } from '../../interfaces/recharge';
import Input from '../../components/Input';
import Button from '../../components/Button';
import DropdownButton from '../../components/DropdownButton';
import RechargeOrdersTable from './components/RechargeOrdersTable';
import CreateOrderByValueModal from './components/CreateOrderByValueModal';
import CreateOrderByNumber from './components/CreateOrderByNumber';
import CreateOrderByImport from './components/CreateOrderByImport';
import RechargeOrderFilterModal from './components/RechargeOrderFIlterModal';
import GenerateReportModal from './components/GenerateReportModal';
import RechargeService from '../../services/recharge';
import ConfirmationModal from '../../components/ConfirmationModal';
import LoaderModal from '../../components/LoaderModal';
import HeaderMotiva from '../../components/HeaderMotiva';
import AuthService from '../../services/auth';
import {
  Row,
  Column,
  IconContainer,
  InfoContainer,
  InfoItem,
} from '../../styles/components';
import {
  BaseContainer,
  Container,
  Title,
  ButtonsContainerInitial,
  FiltersContainer,
  StatusRow,
  ButtonsContainer,
  ModalContent,
  FormWrapper,
  LinkModal,
  ModalContentCancelar,
} from './styles';
import GenerateReportModalAsync from './components/GenerateReportModalAsync';
import Modal from '../../components/Modal';

const RechargeOrders: React.FC = () => {
  const services = { RechargeService: new RechargeService() };
  const { addToast } = useToast();
  const { push } = useHistory();
  const formRef = useRef<FormHandles>(null);

  const [loading, setLoading] = useState<boolean>(true);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [showReportModalAsync, setShowReportModalAsync] =
    useState<boolean>(false);
  const [reportType, setReportType] = useState<string>('');
  const [showCreateByValue, setShowCreateByValue] = useState<boolean>(false);
  const [showCreateByNumber, setShowCreateByNumber] = useState<boolean>(false);
  const [showCreateByImport, setShowCreateByImport] = useState<boolean>(false);
  const [modalRelatorio, setModalRelatorio] = useState<boolean>(false);
  const [page, setpage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(30);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [selectedRechargeOrder, setSelectedRechargeOrder] = useState(null);
  const [modalAvisoCancelar, setModalAvisoCancelar] = useState<boolean>(false);
  const [titular, setTitular] = useState<any>();
  const authService = { AuthService: new AuthService() };

  const [showDuplicateConfirmation, setShowDuplicateConfirmation] =
    useState<boolean>(false);

  const [showRemoveRechargeOrder, setShowRemoveRechargeOrder] =
    useState<boolean>(false);

  const [showCancelRechargeOrder, setShowCancelRechargeOrder] =
    useState<boolean>(false);

  const [rechargeOrders, setRechargeOrders] = useState<RechargeTicketOrders>(
    {} as RechargeTicketOrders,
  );

  const [filters, setFilters] = useState<ArrayFilters>({
    filters: [{ page }, { quantity: perPage }, { sort: '{ "date": "desc" }' }],
  });
  const getTitular = useCallback(async () => {
    try {
      setLoading(true);
      const response = await authService.AuthService.getTitular();
      await setTitular(response.data.DadosDoTitular);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }, []);

  function relatorio() {
    push('/agendado');
  }

  useEffect(() => {
    localStorage.removeItem('@TransfacilPJ:start_date');
    localStorage.removeItem('@TransfacilPJ:end_date');
  }, []);

  const getRechargeOrders = useCallback(async () => {
    try {
      setLoading(true);
      const response = await services.RechargeService.getRechargeOrders(
        filters,
      );
      setRechargeOrders(response.data);
      setTotalRows(response.data.ListaDadosPedidosCargaTotal);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [filters]);
  const RechargeOrderOptions = [
    {
      name: 'Por valor',
      onClick: () => setShowCreateByValue(true),
    },
    {
      name: 'Por número de dias',
      onClick: () => setShowCreateByNumber(true),
    },
    {
      name: 'Importação',
      onClick: () => setShowCreateByImport(true),
    },
  ];

  const handleNumberOrderFilter = useCallback(
    (data: any) => {
      setFilters({
        filters: [...filters.filters, { 'code-orders': data.search }],
      });
    },
    [filters],
  );

  const handleClearFilters = useCallback(() => {
    localStorage.removeItem('@TransfacilPJ:start_date');
    localStorage.removeItem('@TransfacilPJ:end_date');
    setFilters({
      filters: [{ page }, { quantity: perPage }],
    });
  }, []);

  const handleChangePerPage = useCallback(
    async (newPage: number) => {
      setpage(newPage);
      setFilters({ filters: [...filters.filters, { page: newPage }] });
    },
    [filters],
  );

  const handleChangeRowsPerPage = useCallback(
    async (newPerPage: number, OldPerPage: number) => {
      setPerPage(newPerPage);
      setpage(OldPerPage);
      setFilters({
        filters: [
          ...filters.filters,
          { page: OldPerPage },
          { quantity: newPerPage },
        ],
      });
    },
    [filters],
  );

  const handleApplyFilter = useCallback((filtersOptions: any) => {
    setFilters({
      filters: [
        ...filters.filters,
        filtersOptions.start_date && {
          'start-date': filtersOptions.start_date,
        },
        filtersOptions.end_date && { 'end-date': filtersOptions.end_date },
      ],
    });
    setShowModal(false);
  }, []);

  const handleCallConfirmationModal = useCallback((data: any, type: any) => {
    setSelectedRechargeOrder(data);
    if (type === 'duplicate') setShowDuplicateConfirmation(true);
    if (type === 'remove') setShowRemoveRechargeOrder(true);
    if (type === 'cancel') setShowCancelRechargeOrder(true);
  }, []);

  const handleDuplicate = useCallback(async (data: any) => {
    try {
      const duplicateData = {
        data: { CodigoPedido: String(data.Codigo) },
        'type-recharge': 'clone',
      };

      await services.RechargeService.createRechargeOrders(duplicateData);

      getRechargeOrders();

      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Pedido de Recarga feito com sucesso!!',
      });
    } catch (err: any) {
      const { ...error } = err;
      addToast({
        type: 'error',
        title: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}`,
        description: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`,
      });
    }
  }, []);

  const handleRemoveRechargeOrder = useCallback(async (data: any) => {
    try {
      await services.RechargeService.removeRechargeOrder(String(data.Codigo));
      getRechargeOrders();
      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Pedido Removido!!',
      });
    } catch (err: any) {
      const { ...error } = err;
      console.error(error);
    }
  }, []);

  const handleCreateBillet = useCallback(async (data: any) => {
    try {
      setLoadingModal(true);
      const response = await services.RechargeService.getRechargeBillet(
        String(data.Codigo),
      );
      const isFile = isArrayBuffer(response.data);

      if (isFile) {
        DownLoadFile(response.data, `boletoPedido${data.Codigo}.pdf`);
      } else {
        const errorResponse = ConverArrayBufferToData(response.data);
        addToast({
          type: 'error',
          title: `${errorResponse.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}`,
          description: `${errorResponse.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`,
        });
      }
      setLoadingModal(false);
    } catch (err: any) {
      setLoadingModal(false);
      const { ...error } = err;
      console.error(error);
    }
  }, []);

  const handleCreateReceipt = useCallback(async (data: any) => {
    try {
      setLoadingModal(true);
      const response = await services.RechargeService.getRechargeReceipt(
        String(data.Codigo),
      );

      DownLoadFile(response.data, `ReciboPedido${data.Codigo}.pdf`);
      setLoadingModal(false);
    } catch (err: any) {
      setLoadingModal(false);
      const { ...error } = err;
      const errorResponse = ConverArrayBufferToData(error.response.data);

      if (errorResponse.Summary.ErrorCollection.SystemFailureErros.length) {
        addToast({
          type: 'error',
          title: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
          description: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
        });
      }
    }
  }, []);

  const handleCancelRechargeOrder = useCallback(async (data: any) => {
    try {
      await services.RechargeService.cancelRechargeOrder(String(data.Codigo));
      setModalAvisoCancelar(true);
      getRechargeOrders();
      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Pedido cancelado!!',
      });
    } catch (err: any) {
      const { ...error } = err;
      console.error(error);
    }
  }, []);

  const handleAddRechargeByValue = useCallback(async (data: any) => {
    try {
      const postData = {
        data: {
          ValorCarga: String(data.valor),
          CodigoDepartamento: String(data.departamento),
        },
        'type-recharge': 'value',
      };

      const response = await services.RechargeService.createRechargeOrders(
        postData,
      );

      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Pedido de Recarga feito com sucesso!!',
      });

      push(`/pedidos-de-recarga/${response.data.CodigoPedido}`);
    } catch (err: any) {
      const { ...error } = err;
      addToast({
        type: 'error',
        title: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}`,
        description: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`,
      });
    }
  }, []);

  const handleAddRechargeByNumber = useCallback(async (data: any) => {
    try {
      const postData = {
        data: {
          NumeroDias: String(data.numero),
          CodigoDepartamento: String(data.departamento),
        },
        'type-recharge': 'number',
      };

      const response = await services.RechargeService.createRechargeOrders(
        postData,
      );

      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Pedido de Recarga feito com sucesso!!',
      });

      push(`/pedidos-de-recarga/${response.data.CodigoPedido}`);
    } catch (err: any) {
      const { ...error } = err;
      addToast({
        type: 'error',
        title: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}`,
        description: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`,
      });
    }
  }, []);

  const handleShowGenerateModal = useCallback(async (type: string) => {
    await setReportType(type);
    setShowReportModal(true);
  }, []);

  const handleShowGenerateModalAsync = useCallback(async (type: string) => {
    await setReportType(type);
    setShowReportModalAsync(true);
  }, []);

  const handleGeneretaReport = useCallback(
    async (data: any) => {
      const reportFilters = {
        filters: [
          { 'start-date': data.start_date },
          { 'end-date': data.end_date },
          { sorting: data.sorting },
          { 'file-type': data['file-type'] },
          { 'employee-code': data.employee_code },
          { 'code-order-recharge': data.code_order_recharge },
        ],
      };
      if (data.employee_code === '') delete reportFilters.filters[4];
      if (data.code_order_recharge === '') delete reportFilters.filters[5];
      const type = data['file-type'] === 'C' ? 'csv' : 'pdf';

      try {
        const response = await services.RechargeService.getRechargeReport(
          reportFilters,
          type,
        );
        DownLoadFile(response.data, `relatórioPedidodeRecarga.${type}`);
      } catch (err: any) {
        setLoading(false);
        const { ...error } = err;
        if (error.response.data.Summary) {
          addToast({
            type: 'error',
            title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
            description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
          });
        } else {
          addToast({
            type: 'error',
            title: 'Não foi possivel executar o serviço.',
            description: 'Não existem dados para serem impressos.',
          });
        }
      }
    },
    [addToast],
  );

  const handleGeneretaReportAsync = useCallback(
    async (data: any) => {
      const reportFilters = {
        filters: [
          { 'start-date': data.start_date },
          { 'end-date': data.end_date },
          { sorting: data.sorting },
          { 'file-type': data['file-type'] },
          { 'employee-code': data.employee_code },
          { 'code-order-recharge': data.code_order_recharge },
        ],
      };
      if (data.employee_code === '') delete reportFilters.filters[4];
      if (data.code_order_recharge === '') delete reportFilters.filters[5];
      const type = data['file-type'] === 'C' ? 'csv' : 'pdf';

      try {
        await services.RechargeService.getRechargeReport(reportFilters, type);
        setModalRelatorio(true);
      } catch (err: any) {
        setLoading(false);
        const { ...error } = err;
        if (error.response.data.Summary) {
          addToast({
            type: 'error',
            title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
            description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
          });
        } else {
          addToast({
            type: 'error',
            title: 'Não foi possivel executar o serviço.',
            description: 'Não existem dados para serem impressos.',
          });
        }
      }
    },
    [addToast, titular],
  );
  const getStatusText = useCallback((status: any) => {
    const statusOptions: any = {
      C: 'A PAGAR',
      F: 'FINALIZADO',
      E: 'EM ANDAMENTO',
      B: 'A PAGAR',
      P: 'PAGO',
    };
    return statusOptions[status];
  }, []);

  useEffect(() => {
    getRechargeOrders();
    getTitular();
  }, [page, perPage, filters]);

  return (
    <Container>
      <HeaderMotiva />
      <Row className="titleWrapper">
        <Column small="2" medium="2" large="2">
          <IconContainer align="center">
            <IoCartOutline />
          </IconContainer>
        </Column>
        <Column small="9" medium="9" large="9" className="TitleContainer">
          <div>
            <Title>Pedidos de Recarga</Title>
            <ButtonsContainerInitial>
              <div className="buttonsInitial">
                <DropdownButton
                  color="orange"
                  itens={RechargeOrderOptions}
                  padding="2"
                  type="button"
                  className="pedido"
                >
                  SOLICITAR RECARGA
                </DropdownButton>
              </div>
            </ButtonsContainerInitial>
          </div>
        </Column>
      </Row>
      <Row>
        <Column small="2" medium="2" large="2" />
        <Column small="10" medium="10" large="10">
          <FiltersContainer>
            <div className="filter">
              <Button
                color="aside-background"
                padding="1"
                textBlack
                type="button"
                className="pdf"
                onClick={() => setShowModal(true)}
              >
                <MdFilterList />
                FILTROS
              </Button>
            </div>
            <div className="search">
              <Form ref={formRef} onSubmit={handleNumberOrderFilter}>
                <Input
                  id="search"
                  name="search"
                  type="number"
                  placeholder="Busca por código do pedido"
                />
                <Button
                  color="orange"
                  padding="1"
                  type="submit"
                  className="searchButton"
                >
                  <MdSearch size={20} />
                </Button>
              </Form>
            </div>
            <div className="buttonsContainer">
              <Button
                color="aside-background"
                padding="1"
                type="button"
                className="clearFilters"
                onClick={handleClearFilters}
              >
                <MdFilterList />
                LIMPAR FILTROS
              </Button>
              <Button
                color="purple"
                padding="1"
                type="button"
                className="csv"
                onClick={() => {
                  if (titular.BalanceView === true) {
                    if (titular.AsyncReport === true) {
                      handleShowGenerateModalAsync('C');
                    } else {
                      handleShowGenerateModal('C');
                    }
                  } else {
                    if (titular.AsyncReport === true) {
                      handleShowGenerateModalAsync('C');
                    } else {
                      handleShowGenerateModal('C');
                    }
                  }
                }}
              >
                <HiDownload />
                GERAR CSV
              </Button>
              <Button
                color="purple"
                padding="1"
                type="button"
                className="pdf"
                onClick={() => {
                  if (titular.BalanceView === true) {
                    if (titular.AsyncReport === true) {
                      handleShowGenerateModalAsync('P');
                    } else {
                      handleShowGenerateModal('P');
                    }
                  } else {
                    if (titular.AsyncReport === true) {
                      handleShowGenerateModalAsync('P');
                    } else {
                      handleShowGenerateModal('P');
                    }
                  }
                }}
              >
                <HiDownload />
                GERAR PDF
              </Button>
            </div>
          </FiltersContainer>
        </Column>
      </Row>
      <Row>
        <Column small="2" medium="2" large="2">
          <InfoContainer>
            <h4 className="title">Métodos de Recarga:</h4>
            {/* <InfoItem className="infoitem">
                <span className="info">&#9432;</span>
                <span className="ajuda">
                  <p className="text">
                    <strong>Por Valor:</strong>
                  </p>
                  <p>
                    Você escolhe o departamento e em seguida o valor financeiro
                    que cada funcionário associado àquele departamento deverá
                    receber carga.
                  </p>
                </span>
              </InfoItem> */}
            <InfoItem className="infoitem">
              <span className="info">&#9432;</span>
              <span className="ajuda">
                <p className="text">
                  <strong>Pedido por dia:</strong>
                </p>
                <p>
                  Você escolhe o departamento e o número de dias que cada
                  funcionário deverá receber carga. O sistema calculará
                  automaticamente o valor de recarga por dia de cada funcionário
                  com base no cadastro de Tarifas por Dia dele, disponível na
                  tela de cadastro de funcionário.
                </p>
              </span>
            </InfoItem>
            <InfoItem className="infoitem">
              <span className="info">&#9432;</span>
              <span className="ajuda">
                <p className="text">
                  <strong>Pedido por importação de arquivo:</strong>
                </p>
                <p>
                  Através de um formato padronizado é possível associar
                  individualmente um valor de recarga por funcionário através do
                  campo “matrícula”, disponível na tela de cadastro de cada
                  funcionário.
                </p>
              </span>
            </InfoItem>
          </InfoContainer>
        </Column>
        <Column small="10" medium="10" large="10">
          <RechargeOrdersTable
            data={rechargeOrders.ListaDadosPedidosCarga}
            columns={[
              {
                name: 'Código',
                selector: 'DadosDoPedidoDeRecarga.Codigo',
                maxWidth: '10%',
                cell: ({ DadosDoPedidoDeRecarga }: any) => (
                  <Link
                    to={`/pedidos-de-recarga/${DadosDoPedidoDeRecarga.Codigo}`}
                    style={{
                      textDecoration: 'underline',
                      textUnderlinePosition: 'under',
                    }}
                  >
                    {DadosDoPedidoDeRecarga.Codigo}
                  </Link>
                ),
              },
              {
                name: 'Status',
                center: true,
                selector: 'DadosDoPedidoDeRecarga.Status',
                maxWidth: '120%',
                cell: ({ DadosDoPedidoDeRecarga }: any) => (
                  <StatusRow status={DadosDoPedidoDeRecarga.Status}>
                    {getStatusText(DadosDoPedidoDeRecarga.Status)}
                  </StatusRow>
                ),
              },
              {
                name: 'Data',
                selector: 'DadosDoPedidoDeRecarga.Data',
                maxWidth: '50%',
              },
              {
                name: 'Valor',
                selector: 'DadosDoPedidoDeRecarga.Valor',
                maxWidth: '15%',
                cell: ({ DadosDoPedidoDeRecarga }: any) => (
                  <div>{`R$ ${DadosDoPedidoDeRecarga.Valor}`}</div>
                ),
              },
              {
                name: 'Ações',
                selector: 'DadosDoPedidoDeRecarga.Codigo',
                cell: ({ DadosDoPedidoDeRecarga }: any) => (
                  <ButtonsContainer>
                    <button
                      type="button"
                      className="green"
                      title="Duplicar"
                      onClick={() => {
                        return handleCallConfirmationModal(
                          DadosDoPedidoDeRecarga,
                          'duplicate',
                        );
                      }}
                    >
                      <MdContentCopy style={{ color: '#3F1159' }} />
                    </button>
                    {(DadosDoPedidoDeRecarga.Status === 'C' ||
                      DadosDoPedidoDeRecarga.Status === 'F' ||
                      DadosDoPedidoDeRecarga.Status === 'P' ||
                      DadosDoPedidoDeRecarga.Status === 'B') && (
                      <button
                        type="button"
                        className="white"
                        title="Emitir Boleto"
                        onClick={() =>
                          handleCreateBillet(DadosDoPedidoDeRecarga)
                        }
                      >
                        <FaBarcode style={{ color: '#3F1159' }} />
                      </button>
                    )}
                    {DadosDoPedidoDeRecarga.Status === 'E' && (
                      <button
                        type="button"
                        className="red"
                        title="Remover"
                        onClick={() => {
                          return handleCallConfirmationModal(
                            DadosDoPedidoDeRecarga,
                            'remove',
                          );
                        }}
                      >
                        <FaTrash style={{ color: '#EB5E35' }} />
                      </button>
                    )}
                    {(DadosDoPedidoDeRecarga.Status === 'C' ||
                      DadosDoPedidoDeRecarga.Status === 'B') && (
                      <button
                        type="button"
                        className="cancel"
                        title="Cancelar"
                        onClick={() => {
                          return handleCallConfirmationModal(
                            DadosDoPedidoDeRecarga,
                            'cancel',
                          );
                        }}
                      >
                        <VscChromeClose
                          size={32}
                          style={{ color: '#EB5E35' }}
                        />
                      </button>
                    )}
                    {(DadosDoPedidoDeRecarga.Status === 'F' ||
                      DadosDoPedidoDeRecarga.Status === 'P') && (
                      <button
                        type="button"
                        className="white"
                        title="Emitir Recibo"
                        onClick={() =>
                          handleCreateReceipt(DadosDoPedidoDeRecarga)
                        }
                      >
                        <FaReceipt style={{ color: '#3F1159' }} />
                      </button>
                    )}
                  </ButtonsContainer>
                ),
              },
            ]}
            loading={loading}
            totalRows={totalRows}
            perPage={perPage}
            onChangePage={handleChangePerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            emptyText="Nenhum Pedido de Recarga"
          />
        </Column>
      </Row>
      {modalRelatorio && (
        <Modal
          handleClose={() => setModalRelatorio(false)}
          show={modalRelatorio}
          title="Agendamento de Relatório"
        >
          <ModalContent>
            <FormWrapper>
              <p>Estamos processando os dados do pedido do Relatório.</p>
              <p>
                <LinkModal onClick={relatorio}>Clique Aqui!</LinkModal>
                Para abrir o menu Relatórios Agendados e acompanhar o Pedido
                solicitado. Quando este processo for finalizado basta fazer o
                download do arquivo.
              </p>
            </FormWrapper>
          </ModalContent>
        </Modal>
      )}
      {showModal && (
        <RechargeOrderFilterModal
          handleClose={() => setShowModal(false)}
          handleApplyFilter={handleApplyFilter}
          show={showModal}
          title="Filtros"
        />
      )}
      {showCreateByValue && (
        <CreateOrderByValueModal
          handleClose={() => setShowCreateByValue(false)}
          handleAdd={handleAddRechargeByValue}
          show={showCreateByValue}
          title="Pedido de Recarga Por Valor"
        />
      )}
      {showCreateByNumber && (
        <CreateOrderByNumber
          handleClose={() => setShowCreateByNumber(false)}
          handleAdd={handleAddRechargeByNumber}
          show={showCreateByNumber}
          title="Pedido de Recarga Por número de dias"
        />
      )}
      {showCreateByImport && (
        <CreateOrderByImport
          handleClose={() => setShowCreateByImport(false)}
          handleAdd={getRechargeOrders}
          show={showCreateByImport}
          title="Importação em massa"
        />
      )}
      {showReportModal && (
        <GenerateReportModal
          handleClose={() => setShowReportModal(false)}
          handleAdd={data => handleGeneretaReport(data)}
          show={showReportModal}
          type={reportType}
          title={`Gerar ${reportType === 'C' ? 'CSV' : 'PDF'}`}
        />
      )}
      {showReportModalAsync && (
        <GenerateReportModalAsync
          handleClose={() => setShowReportModalAsync(false)}
          handleAdd={data => handleGeneretaReportAsync(data)}
          show={showReportModalAsync}
          type={reportType}
          title={`Gerar ${reportType === 'C' ? 'CSV' : 'PDF'}`}
        />
      )}
      {showDuplicateConfirmation && (
        <ConfirmationModal
          title="Duplicar Pedido de Recarga"
          text="Tem certeza que você deseja Criar outro pedido baseado nesse Pedido de Recarga?"
          show={showDuplicateConfirmation}
          handleClose={() => setShowDuplicateConfirmation(false)}
          handleSuccess={() => handleDuplicate(selectedRechargeOrder)}
        />
      )}
      {showRemoveRechargeOrder && (
        <ConfirmationModal
          title="Remoção de pedido de recarga"
          text="Tem certeza que você deseja Remover este Pedido de Recarga?"
          show={showRemoveRechargeOrder}
          handleClose={() => setShowRemoveRechargeOrder(false)}
          handleSuccess={() => handleRemoveRechargeOrder(selectedRechargeOrder)}
        />
      )}
      {showCancelRechargeOrder && (
        <ConfirmationModal
          title="Cancelamento de pedido de recarga"
          text="Tem certeza que você deseja Cancelar este Pedido de Recarga?"
          show={showCancelRechargeOrder}
          handleClose={() => setShowCancelRechargeOrder(false)}
          handleSuccess={() => handleCancelRechargeOrder(selectedRechargeOrder)}
        />
      )}

      {loadingModal && (
        <LoaderModal
          title="Carregando"
          show={loadingModal}
          handleClose={() => setLoadingModal(false)}
        />
      )}
      {modalAvisoCancelar && (
        <Modal
          handleClose={() => setModalAvisoCancelar(false)}
          show={modalAvisoCancelar}
          title="Atenção!"
        >
          <ModalContentCancelar>
            <FormWrapper>
              <p>
                Após refazer o pedido, certifique-se de utilizar o novo boleto
                para efetuar o pagamento.
              </p>
            </FormWrapper>
          </ModalContentCancelar>
        </Modal>
      )}
    </Container>
  );
};

export default RechargeOrders;
